<template lang="html">
    <div class="component__loader-spinner">
        <div class="loader">
            <svg class="circular" viewBox="25 25 50 50">
                <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="4" stroke-miterlimit="10"/>
            </svg>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'z-loader-spinner',
        data() {
            return {}
        },
        created() {},
    }
</script>
<style scoped lang="sass">
    .component__loader-spinner
        display: flex
        align-items: center
        justify-content: center
        width: 25px
        height: 25px
        cursor: wait

        .loader
            position: relative
            width: 25px
            height: 25px

            &:before
                content: ''
                display: block
                padding-top: 100%
        .circular
            animation: rotate 2s linear infinite
            height: 100%
            transform-origin: center center
            width: 100%
            position: absolute
            top: 0
            bottom: 0
            left: 0
            right: 0
            margin: auto
        .path
            stroke-dasharray: 1, 200
            stroke-dashoffset: 0
            animation: dash 1.5s ease-in-out infinite, color 6s ease-in-out infinite
            stroke-linecap: round
            stroke: var(--md-theme-default-primary, #2196f3)

        @keyframes rotate
            100%
                transform: rotate(360deg)
        @keyframes dash
            0%
                stroke-dasharray: 1, 200
                stroke-dashoffset: 0
            50%
                stroke-dasharray: 89, 200
                stroke-dashoffset: -35px
            100%
                stroke-dasharray: 89, 200
                stroke-dashoffset: -124px
</style>



// WEBPACK FOOTER //
// ZLoaderSpinner.vue?4b669d84